import { computed, ref } from 'vue'
import { Column } from '../utils/v-table'

type ColumnDef = {
  key: string
  label: string
  hidden?: boolean
}

export function useColumnVisibility(columns: ColumnDef[]) {
  const defaultVisibleKeys = columns.filter((col) => !col.hidden).map((col) => col.key)

  const visibleColumnKeys = ref<string[]>(defaultVisibleKeys)

  const resolvedColumns = computed(() =>
    columns.map((col) => ({
      ...col,
      hidden: !visibleColumnKeys.value.includes(col.key),
    })),
  )

  const columnOptions = computed(() =>
    columns.map((col) => ({
      value: col.key,
      text: col.label,
    })),
  )

  const resetColumns = () => {
    visibleColumnKeys.value = [...defaultVisibleKeys]
  }

  return {
    visibleColumnKeys,
    resolvedColumns,
    columnOptions,
    resetColumns,
  }
}
